import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserPenEditOutline = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 17,
	viewBox: "0 0 19 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_12182_107817)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 15V13.2C0 12.6333 0.146 12.1127 0.438 11.638C0.73 11.1633 1.11733 10.8007 1.6 10.55C2.63333 10.0333 3.68333 9.646 4.75 9.388C5.81667 9.13 6.9 9.00067 8 9C8.61667 9 9.225 9.03767 9.825 9.113C10.425 9.18833 11.025 9.309 11.625 9.475L9.95 11.175C9.61667 11.125 9.29167 11.0833 8.975 11.05C8.65833 11.0167 8.33333 11 8 11C7.06667 11 6.14167 11.1127 5.225 11.338C4.30833 11.5633 3.4 11.9007 2.5 12.35C2.35 12.4333 2.229 12.55 2.137 12.7C2.045 12.85 1.99933 13.0167 2 13.2V14H8V16H1C0.716667 16 0.479333 15.904 0.288 15.712C0.0966668 15.52 0.000666667 15.2827 0 15ZM10 16V14.75C10 14.4833 10.0543 14.229 10.163 13.987C10.2717 13.745 10.4173 13.5327 10.6 13.35L15.525 8.425C15.675 8.275 15.8417 8.16667 16.025 8.1C16.2083 8.03333 16.3917 8 16.575 8C16.775 8 16.9667 8.03767 17.15 8.113C17.3333 8.18833 17.5 8.30067 17.65 8.45L18.575 9.375C18.7083 9.525 18.8127 9.69167 18.888 9.875C18.9633 10.0583 19.0007 10.2417 19 10.425C18.9993 10.6083 18.966 10.796 18.9 10.988C18.834 11.18 18.7257 11.3507 18.575 11.5L13.65 16.425C13.4667 16.6083 13.2543 16.75 13.013 16.85C12.7717 16.95 12.5173 17 12.25 17H11C10.7167 17 10.4793 16.904 10.288 16.712C10.0967 16.52 10.0007 16.2827 10 16ZM11.5 15.5H12.45L15.475 12.45L15.025 11.975L14.55 11.525L11.5 14.55V15.5ZM15.025 11.975L14.55 11.525L15.475 12.45L15.025 11.975ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM8 6C8.55 6 9.021 5.80433 9.413 5.413C9.805 5.02167 10.0007 4.55067 10 4C9.99933 3.44933 9.80367 2.97867 9.413 2.588C9.02233 2.19733 8.55133 2.00133 8 2C7.44867 1.99867 6.978 2.19467 6.588 2.588C6.198 2.98133 6.002 3.452 6 4C5.998 4.548 6.194 5.019 6.588 5.413C6.982 5.807 7.45267 6.00267 8 6Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_12182_107817",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 19,
				height: 17,
				fill: "none"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUserPenEditOutline);
export { ForwardRef as ReactComponent };
